export const privacyPolicyData = [
  {
    id: "section-1",
    heading: "1. Introduction",
    content: [
      "Welcome to Mooshir. This Privacy Policy explains how we handle your personal data when you use our services.",
      "**By using our services, you agree to the terms outlined in this policy.**"
    ]
  },
  {
    id: "section-2",
    heading: "2. Information We Collect",
    content: [
      "We may collect the following types of personal information:",
      {
        type: "list",
        items: [
          "Contact details such as name, email address, and phone number",
          "Account login credentials",
          "Device information including IP address, browser type, and operating system",
          "Usage data such as pages visited and interactions with our services"
        ]
      }
    ]
  },
  {
    id: "section-3",
    heading: "3. How We Use Your Information",
    content: [
      "We use your information for the following purposes:",
      {
        type: "list",
        items: [
          "To provide, maintain, and improve our services",
          "To communicate with you about your account",
          "To personalize your experience",
          "To comply with legal obligations"
        ]
      }
    ]
  },
  {
    id: "section-4",
    heading: "4. Sharing Your Information",
    content: [
      "We do not sell your personal data. We may share information with:",
      {
        type: "list",
        items: [
          "Service providers who perform services on our behalf",
          "Legal authorities when required by law",
          "Business partners with your consent"
        ]
      }
    ]
  },
  {
    id: "section-5",
    heading: "5. Data Retention",
    content: [
      "We retain your personal information only as long as necessary for the purposes described in this policy or as required by law."
    ]
  },
  {
    id: "section-6",
    heading: "6. Your Rights",
    content: [
      {
        type: "list",
        items: [
          "Right to access and obtain a copy of your data",
          "Right to request correction of inaccurate data",
          "Right to request deletion of your data",
          "Right to object to processing"
        ]
      }
    ]
  },
  {
    id: "section-7",
    heading: "7. Contact Us",
    content: [
      "If you have any questions about this Privacy Policy, please contact us at:",
      "**Email:** support@mooshir.com"
    ]
  }
];
